const trimmedBase =
  typeof process.env.NEXT_PUBLIC_API_URL === 'string'
    ? process.env.NEXT_PUBLIC_API_URL.replace(/\/+$/, '')
    : '';

export function publicApiPath(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return trimmedBase ? `${trimmedBase}${p}` : p;
}

export function publicMediaUrl(pathOrUrl: string): string {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return publicApiPath(pathOrUrl);
}
